import '@archetype-themes/scripts/config';

theme.QtySelector = (function () {
  var selectors = {
    input: '.js-qty__num',
    plus: '.js-qty__adjust--plus',
    minus: '.js-qty__adjust--minus'
  };

  function QtySelector(el, options) {
    this.wrapper = el;
    this.plus = el.querySelector(selectors.plus);
    this.minus = el.querySelector(selectors.minus);
    this.input = el.querySelector(selectors.input);
    this.minValue = this.input.getAttribute('min') || 1;

    var defaults = {
      namespace: null,
      isCart: false,
      isProduct: true,
      key: this.input.dataset.id
    };

    this.options = Object.assign({}, defaults, options);

    this.init();
  }

  QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
    init: function () {
      this.plus.addEventListener('click', function () {
        var qty = this._getQty();
        var stepUp = this._getStep(); //Qty Incr/Decr Step value
        this._change(qty + stepUp);
      }.bind(this));

      this.minus.addEventListener('click', function () {
        var qty = this._getQty();
        var stepDown = this._getStep(); //Qty Incr/Decr Step value
        this._change(qty - stepDown);
      }.bind(this));

      this.input.addEventListener('change', function (evt) {
        this._change(this._getQty());
      }.bind(this));
    },

    _getQty: function () {
      var qty = this.input.value;
      if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        qty = 1;
      }
      return parseInt(qty);
    },

    // Funtion to fetch Qty increments
    _getStep: function () {
      var step = this.input.step;
      if ((parseFloat(step) == parseInt(step)) && !isNaN(step)) {
      } else {
        step = 1;
      }
      return parseInt(step);
    },

    // Function to fetch template classname of element
    _getTemplate: function () {
      var tempClass = this.input.getAttribute('data-template');
      return tempClass;
    },

    // Function to show add to cart and hide quantity selector
    _showAddToCartHideQuantity: function (product_id) {
      const qtyElement = document.querySelectorAll(
        '[data-product-id-quantity= "' + product_id + '"]'
      );

      [].forEach.call(qtyElement, function (el) {
        const delay = 1000;
        setTimeout(() => {
          el.classList.add("quantity-selector-disable");
        }, delay);
      });

      const addToCartElement = document.querySelectorAll(
        '[data-product-id-add= "' + product_id + '"]'
      );

      [].forEach.call(addToCartElement, function (el) {
        const delay = 1000;
        setTimeout(() => {
          el.classList.remove("addtocart-disable");
        }, delay);
      });
    },

    _change: function (qty) {
      if (qty <= this.minValue) {
        qty = this.minValue;
      }

      this.input.value = qty;
      //Custom check to pass template collection namespace
      if(this._getTemplate() == 'collection'){
        this.options.namespace = '.template-collection';      
      } 
      if(qty == 0){ 
        var pidArr = this.options.key.split(":");
        this._showAddToCartHideQuantity(pidArr[0]); //Show Add to cart button for Grid item if item get removed from cart
      } 
      if (this.options.isCart || this.options.isProduct) {
        document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
          detail: [this.options.key, qty, this.wrapper]
        }));
      }
    }
  });

  return QtySelector;
})();
